export { CLIENT_RADIO_OTHERS_INPUT_VALUE as RADIO_OTHERS_INPUT_VALUE } from '~shared/constants'

export const RADIO_OTHERS_INPUT_KEY = 'othersInput'
